var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_17793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3876 0.00646114C15.9565 0.110145 15.5847 0.200474 15.213 0.288447C14.2156 0.525661 13.2206 0.771516 12.2193 0.990664C11.9686 1.04565 11.9788 1.13362 12.1092 1.28443C12.2943 1.49887 12.4919 1.70309 12.684 1.91203C12.7902 2.02749 12.7817 2.13589 12.6684 2.2435C12.2927 2.60168 11.9202 2.963 11.5445 3.32118C11.147 3.70056 10.7416 4.07209 10.3519 4.45855C10.2168 4.59286 10.1418 4.62036 9.99185 4.46405C9.06243 3.49791 8.11584 2.54905 7.18642 1.58291C6.99976 1.3889 6.9076 1.37398 6.69672 1.57899C5.58611 2.6598 4.4505 3.71391 3.32427 4.77902C2.43547 5.62027 1.55135 6.46544 0.660989 7.30276C0.468076 7.48421 0.430587 7.62402 0.647711 7.82746C1.00386 8.16129 1.33423 8.52339 1.66929 8.87921C1.80206 9.0206 1.90437 9.05123 2.06448 8.89964C3.01967 7.98927 3.98501 7.0899 4.94333 6.18346C5.533 5.62577 6.12267 5.06651 6.69984 4.49625C6.84824 4.35015 6.94509 4.35879 7.07552 4.49782C7.53632 4.9856 7.99946 5.4726 8.46573 5.95488C8.96793 6.4733 9.47559 6.98543 9.97857 7.50306C10.0778 7.60517 10.166 7.56982 10.2402 7.48892C10.7549 6.9273 11.3618 6.46387 11.8858 5.90932C12.3724 5.39405 12.916 4.93455 13.4346 4.45069C13.6767 4.22448 13.9235 4.00376 14.157 3.7689C14.2843 3.64087 14.3726 3.61966 14.4991 3.7744C14.6655 3.97862 14.8521 4.16792 15.0404 4.35329C15.1778 4.4884 15.2716 4.51746 15.3403 4.26532C15.6004 3.31096 15.8886 2.36446 16.1611 1.41404C16.2752 1.01737 16.3814 0.617563 16.4806 0.216969C16.5079 0.107788 16.5227 -0.0304565 16.3861 0.00646114H16.3876Z",
    fill: "#00AD71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_17793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.7fae0e86245b088af7b725a72a74e34b.svg";
export { ForwardRef as ReactComponent };